import { useEffect, useState } from "react";
import axios from "axios";

const API =
  process.env.REACT_APP_API_URL ||
  "https://homefoods-backend-production.up.railway.app/api";

const initialState = {
  productName: "",
  description: "",
  category: "Cakes",
  price: "",
  offerPrice: "",
  weight: "",
  flavour: "",
  eggType: "Eggless",
  preparationTime: "",
  availableToday: true,
  isAvailable: true,
  isBestSeller: false,
  customCake: false,
  advanceOrder: false,
  stock: "",
  stockStatus: "In Stock",
  image: "",
};

function useBakeryForm(
  selectedProduct,
  fetchProducts,
  closeForm
) {
  const [formData, setFormData] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);

  // ==========================
  // Load product for editing
  // ==========================
  useEffect(() => {
    if (selectedProduct) {
      setEditingId(selectedProduct._id);

      setFormData({
        ...initialState,
        ...selectedProduct,
      });
    } else {
      resetForm();
    }
  }, [selectedProduct]);

  // ==========================
  // Update field
  // ==========================
  const updateField = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // ==========================
  // Reset Form
  // ==========================
  const resetForm = () => {
    setFormData(initialState);
    setEditingId(null);
  };

  // ==========================
  // Validation
  // ==========================
  const validate = () => {
    if (!formData.productName.trim()) {
      alert("Product Name is required.");
      return false;
    }

    if (!formData.price) {
      alert("Price is required.");
      return false;
    }

    if (!formData.offerPrice) {
      alert("Offer Price is required.");
      return false;
    }

    return true;
  };

  // ==========================
  // Submit
  // ==========================
  const submitForm = async () => {
    if (!validate()) return;

    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      const data = new FormData();

      Object.keys(formData).forEach((key) => {
        if (
          formData[key] !== null &&
          formData[key] !== undefined
        ) {
          data.append(key, formData[key]);
        }
      });

      if (editingId) {
        await axios.put(
          `${API}/bakery/${editingId}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        await axios.post(
          `${API}/bakery/add`,
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      await fetchProducts();

      resetForm();

      if (closeForm) {
        closeForm();
      }

    } catch (err) {
      console.error("Save Bakery Product Error:", err);
      alert(
        err.response?.data?.message ||
          "Something went wrong."
      );
    } finally {
      setLoading(false);
    }
  };

  return {
    formData,
    loading,
    editingId,

    updateField,
    submitForm,
    resetForm,
  };
}

export default useBakeryForm;